var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5308 21.4693C22.6713 21.61 22.7502 21.8006 22.7502 21.9993C22.7502 22.1981 22.6713 22.3887 22.5308 22.5293L16.5308 28.5293C16.3902 28.6698 16.1996 28.7487 16.0008 28.7487C15.8021 28.7487 15.6114 28.6698 15.4708 28.5293L9.47082 22.5293C9.33834 22.3872 9.26622 22.1991 9.26965 22.0048C9.27308 21.8105 9.35179 21.6251 9.4892 21.4877C9.62662 21.3503 9.812 21.2716 10.0063 21.2682C10.2006 21.2647 10.3886 21.3369 10.5308 21.4693L16.0008 26.9381L21.4708 21.4693C21.6114 21.3289 21.8021 21.25 22.0008 21.25C22.1996 21.25 22.3902 21.3289 22.5308 21.4693ZM10.5308 10.5293L16.0008 5.06059L21.4708 10.5293C21.613 10.6618 21.801 10.7339 21.9953 10.7305C22.1896 10.7271 22.375 10.6484 22.5124 10.511C22.6499 10.3735 22.7286 10.1882 22.732 9.99386C22.7354 9.79956 22.6633 9.61152 22.5308 9.46934L16.5308 3.46934C16.3902 3.32889 16.1996 3.25 16.0008 3.25C15.8021 3.25 15.6114 3.32889 15.4708 3.46934L9.47082 9.46934C9.33834 9.61152 9.26622 9.79956 9.26965 9.99386C9.27308 10.1882 9.35179 10.3735 9.4892 10.511C9.62662 10.6484 9.812 10.7271 10.0063 10.7305C10.2006 10.7339 10.3886 10.6618 10.5308 10.5293Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIcon);
export default __webpack_public_path__ + "static/media/SortingIcon.4d5030ebe7fc9bd7cd1a1dbf9170f47e.svg";
export { ForwardRef as ReactComponent };